import useCategoryShallowLink from "@components/_hooks/CSRHooks/useCategoryShallowLink";
import useSafePush from "@components/_hooks/useSafePush";
import Link from "next/link";
import { useSelector } from "react-redux";

const fontSize = {
    fontSize: '14px'
}

const FooterLink = ({ link, className = "" }) => {
    const prettified_categories = useSelector(state => state.globalReducer.prettified_categories);
    const {handleShallowLink} = useCategoryShallowLink();
    const {safePush} = useSafePush();
    const navigated = (e, slug, staticPage) => {
        e.preventDefault();
        handleShallowLink(e, slug, staticPage)
        if(typeof window !== 'undefined'){
            window.scrollTo(0, 0);
        }
    }

    const handleLinkClick = (e) => {
        e.preventDefault();
        const foundCategory = prettified_categories.find(cat => cat.slug == link.href.replace(`/`, ''));
        if(foundCategory){
            return navigated(e, foundCategory.slug, false);
        }
        else {
            safePush(link.href);
        }
    }
    
    return (
        <li style={fontSize} className={`${className} pointer mb-3`}>
            {
                link.download ? (
                    <a href={link.href} download>{link.name}</a>
                ) : (
                    <Link style={fontSize} href={link.href} onClick={handleLinkClick}>
                            {link.name}
                    </Link>
                )
            }
        </li>
    );
};

export default FooterLink;
